import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import TableCustom from "./TableCustom";

export default function ModalSelectTableCustom2({
  showMod,
  setShowMod,
  data,
  setData,
  dataTable,
  multi,
  relacion
}) {
  const [show, setShow] = useState(false);
  const [dataTemp, setDataTemp] = useState([]);

  useEffect(() => {
    if (showMod === true) {
      setShow(true);
    }

    console.log("GENERACION");
    console.log(data);
    setDataTemp(data);

  }, [showMod, setShow]);

  const handleClose = () => {
    setShow(false);
    setShowMod(false);
  };

  const retornarSelected = (dataSelected) => {
    let tempSelected = [];
    let temp;
    console.log("ALOPO");
    console.log(data);

    dataTable.dataTable.map((usrMod) => {
      dataSelected.map((usrSelected) => {
        if (usrSelected === usrMod[dataTable.nameId]) {

          if(dataTemp.filter((reg) => {if(reg.idefecto === usrSelected){return reg}}).length !== 0){
            
            temp = dataTemp.filter((reg) => {if(reg.idefecto === usrSelected){return reg}})[0]
            
            temp.tipoEfecto = relacion;
            tempSelected.push(dataTemp.filter((reg) => {if(reg.idefecto === usrSelected){return reg}})[0]);
          }else{
              usrMod.recibido_de = "";              
              usrMod.desencadenado_en = "";              
              usrMod.tipoEfecto = relacion;

            tempSelected.push(usrMod);
          }
        }
      });
    });
    
    tempSelected.map((usrMod) => {});

    setData(tempSelected);
  
  };

  return (
    <>
      <Modal
        size="sm"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="my-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Seleccionar elemento
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dataTable ? (
            <TableCustom
              data={dataTable.dataTable}
              nameCol={dataTable.nameCol}
              nameRow={dataTable.nameRow}
              nameId={dataTable.nameId}
              multi={multi}
              busqueda={dataTable.busqueda}
              nameBusqueda={dataTable.nameBusqueda}
              selectedData={data}
              setSelectedData={setData}
            />
          ) : (
            <p> Debe de incluir los datos para mostrar en la tabla </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="botonPositivo"
            onClick={() => {
              handleClose();
              retornarSelected(data);
            }}
          >
            Aceptar
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <span></span>
    </>
  );
}
